import React from 'react';
import classnames from 'classnames';
import PropTypes from 'prop-types';
import { Select } from '@bingads-webui-react/primitive-validation';
import { LineByLineFormGroup } from '@bingads-webui-cc-react/layout';
import { useValidationI18n } from '../hooks';

export const CountrySelector = ({
  i18n, onCountryChange, countryList, countryCode, alwaysShowError, helpPopupId, helpPopupAriaLabel, isSignupFlow, isOptional, disabled, showEmptyBusinessAIVAddresses, onlyIncludeBusinessAIVAddresses,
}) => {
  const validationI18n = useValidationI18n();
  const onChangeHandler = ({ target: { value: selectedCountryCode } }) => {
    onCountryChange({
      selectedCountryCode,
    });
  };
  const helpPopupTopic = React.useMemo(() => {
    if (helpPopupId.length !== 0) {
      return helpPopupId;
    }
    if (isSignupFlow) {
      return 'Pop_BA_Signup_BusinessLocationTaxInfo';
    }
    if (onlyIncludeBusinessAIVAddresses) {
      return 'pop_BA_AIV_BusinessLoc';
    }
    return 'Pop_BA_Accounts_BusinessLocation';
  }, [helpPopupId, isSignupFlow, onlyIncludeBusinessAIVAddresses]);

  return (
    <LineByLineFormGroup
      contentColClass={classnames('col-xs-6', 'business-location-control')}
      helpPopupTopic={helpPopupTopic}
      helpPopupAriaLabel={helpPopupAriaLabel}
      label={i18n.getString(_TL_('Business location'))}
      id="country-selector"
      className="country-selector"
    >
      <Select
        value={countryCode}
        onChange={onChangeHandler}
        validationProps={{
          i18n: validationI18n,
          alwaysShowError,
          field: 'countryCode',
          data: { countryCode },
          schema: {
            properties: {
              countryCode: {
                type: 'string',
                required: !isOptional,
              },
            },
          },
        }}
        disabled={disabled}
        aria-label={i18n.getString(_TL_('Business location'))}
      >
        <option value="" key="choose" hidden={!showEmptyBusinessAIVAddresses}>{i18n.getString(_TL_('Choose...'))}</option>
        {countryList.map(c => <option value={c.Code} key={c.Code}>{c.Name}</option>)}
      </Select>
    </LineByLineFormGroup>
  );
};

CountrySelector.propTypes = {
  i18n: PropTypes.shape({
    getString: PropTypes.func.isRequired,
  }).isRequired,
  countryList: PropTypes.arrayOf(PropTypes.shape({})).isRequired,
  onCountryChange: PropTypes.func.isRequired,
  alwaysShowError: PropTypes.bool.isRequired,
  countryCode: PropTypes.string,
  helpPopupId: PropTypes.string,
  helpPopupAriaLabel: PropTypes.string,
  isSignupFlow: PropTypes.bool,
  isOptional: PropTypes.bool,
  disabled: PropTypes.bool,
  showEmptyBusinessAIVAddresses: PropTypes.bool,
  onlyIncludeBusinessAIVAddresses: PropTypes.bool,
};

CountrySelector.defaultProps = {
  countryCode: null,
  helpPopupId: '',
  helpPopupAriaLabel: '',
  isSignupFlow: false,
  isOptional: false,
  disabled: false,
  showEmptyBusinessAIVAddresses: false,
  onlyIncludeBusinessAIVAddresses: false,
};
